import React from 'react';

const HostViewContext = React.createContext({});

export default HostViewContext;
